var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarV2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "m9.902 9.769 1.62-5.178a.5.5 0 0 1 .955 0l1.621 5.178H19.5a.5.5 0 0 1 .3.9l-4.298 3.23 1.692 5.206a.5.5 0 0 1-.77.56L12 16.45l-4.424 3.215a.5.5 0 0 1-.77-.56L8.498 13.9 4.2 10.67a.5.5 0 0 1 .3-.9z"
})));
export default SvgStarV2;